module.exports = __webpack_public_path__ + "img/galery13.32f1788d.jpg";